import React from 'react';
import { LocationInventoryV2 } from './locationInventoryV2';

const LocationInventory = () => {
    return <LocationInventoryV2 />;
};

export { LocationInventory };
